<script setup lang="ts">
import { ref } from 'vue';
const props = defineProps<{
  boxId: string;
  requestId?: string | null;
  role: 'admin' | 'provider';
  disabled?: boolean;
}>();
const emit = defineEmits<{ changed: [] }>();
const busy = ref(false);
const error = ref('');
async function withdraw(): Promise<void> {
  if (!props.requestId || busy.value || props.disabled) return;
  if (
    !globalThis.confirm(
      'Confirmez que la Box a été physiquement récupérée pour remplacer son contenu. L’ancien accès dans l’application sera fermé. Les commandes et paiements sont conservés, sans remboursement automatique.',
    )
  )
    return;
  busy.value = true;
  error.value = '';
  try {
    const response = await globalThis.fetch(
      `/${props.role}/api/boxes/${encodeURIComponent(props.boxId)}/withdraw`,
      {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ deliveryRequestId: props.requestId }),
      },
    );
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      throw new Error(
        body.error === 'PHYSICAL_BOX_WITHDRAWAL_PAYMENT_PENDING'
          ? 'Un paiement est encore en cours sur cette Box. Faites-le vérifier avant son retrait.'
          : 'Retrait impossible : actualisez la liste et vérifiez que cette Box est toujours livrée.',
      );
    }
    emit('changed');
  } catch (cause) {
    error.value = cause instanceof Error ? cause.message : 'Retrait impossible.';
  } finally {
    busy.value = false;
  }
}
</script>
<template>
  <div v-if="requestId" class="box-withdrawal">
    <button
      class="button button-danger"
      type="button"
      :disabled="disabled || busy"
      :data-testid="`withdraw-box-${boxId}`"
      @click="withdraw"
    >
      {{ busy ? 'Retrait en cours…' : 'Retirer pour refaire la Box' }}
    </button>
    <p v-if="error" class="flow-error" role="alert">{{ error }}</p>
  </div>
</template>
